import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-lot-moto-jupiter-inspection-comment',
  templateUrl: './lot-moto-jupiter-inspection-comment.component.html',
  styleUrls: ['./lot-moto-jupiter-inspection-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterInspectionCommentComponent {
  @Input() comment: string;
}
